import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { Dictionary } from '@ngrx/entity/src/models';
import * as PartCostsNotSavedChangesActions from './part-costs-not-saved-changes.actions';
import * as PartCostsNotSavedChangesSelectors from './part-costs-not-saved-changes.selectors';
import { PartCostsNotSavedChangesEntity } from './part-costs-not-saved-changes.reducer';

@Injectable()
export class PartCostsNotSavedChangesFacade {
  constructor(private readonly store: Store) {}

  public addPartCostsChangesToStore(partPricingId: string, franchiseMSP: number, isValid: boolean): void {
    this.store.dispatch(
      PartCostsNotSavedChangesActions.updateNotSavedFranchiseMSP({ partPricingId, franchiseMSP, isValid })
    );
  }

  public clearAllChanges(): void {
    this.store.dispatch(PartCostsNotSavedChangesActions.removeAllNotSavedFranchiseMSP());
  }

  public getPartCostsChanges(): Observable<Dictionary<PartCostsNotSavedChangesEntity>> {
    return this.store.pipe(select(PartCostsNotSavedChangesSelectors.getPartCostsNotSavedChangesEntities()));
  }
}
